import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useSelector } from 'react-redux';

function FetThawingTable() {
  const borderRight = { borderRight: '1px solid rgba(224, 224, 224, 1)' };
  const { data } = useSelector((state) => state.dataAnalyticsReducer);
  const getCellData = (key, index) => {
    if (!data || !data[index] || !data[index].frozenDetails) {
      return 'N/A';
    }
    if (key === 'thawingDate') {
      return data[index].frozenDetails.thawingDetails[0].dateOfThawing === ''
        ? 'N/A'
        : new Date(
            data[index].frozenDetails.thawingDetails[0].dateOfThawing,
          ).toLocaleDateString('en-uk');
    }

    if (key === 'dayOfEmbryoCulture') {
      let days = '';

      for (
        let i = 0;
        i < data[index].frozenDetails.thawingDetails.length;
        i++
      ) {
        console.log(
          data[index].frozenDetails.thawingDetails[i].dayOfEmbryoCulture,
        );
        if (
          data[index].frozenDetails.thawingDetails[i].dayOfEmbryoCulture !== ''
        ) {
          days =
            days +
            ' ' +
            data[index].frozenDetails.thawingDetails[i].dayOfEmbryoCulture;
        }
      }
      return days === '' ? 'N/A' : days;
    }

    if (key === 'qualityOfEmbryosBeforeVitrification') {
      const quality = ['N/A', 'N/A', 'N/A'];

      for (
        let i = 0;
        i < Math.min(data[index].frozenDetails.thawingDetails.length, 3);
        i++
      ) {
        quality[i] =
          data[index].frozenDetails.thawingDetails[i].grade === ''
            ? 'N/A'
            : data[index].frozenDetails.thawingDetails[i].grade;
      }

      return quality;
    }

    if (key === 'qualityOfEmbryosAfterThawing') {
      const quality = ['N/A', 'N/A', 'N/A'];

      for (
        let i = 0;
        i < Math.min(data[index].frozenDetails.thawingDetails.length, 3);
        i++
      ) {
        quality[i] =
          data[index].frozenDetails.thawingDetails[i].gradeAtFET === ''
            ? 'N/A'
            : data[index].frozenDetails.thawingDetails[i].gradeAtFET;
      }

      return quality;
    }

    const frozenDetails = data[index].frozenDetails;
    if (frozenDetails[key] === null || frozenDetails[key] === '') {
      return 'N/A';
    }
    return frozenDetails[key] ?? 'N/A';
  };
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell
            colSpan={11}
            style={{
              fontWeight: 700,
              textAlign: 'center',
              ...borderRight,
            }}
          >
            THAWING DETAILS
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell style={{ fontWeight: 700 }}>
            {' '}
            <div
              style={{
                height: '60px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              Date of Thawing
            </div>
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            Day of Embryo Culture
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            No. of Embryos Thawed
          </TableCell>
          <TableCell colSpan={3} style={{ fontWeight: 700 }}>
            Quality of Embryos Before Vitrification{' '}
          </TableCell>
          <TableCell colSpan={3} style={{ fontWeight: 700 }}>
            Quality of Embryos After Thawing{' '}
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>Thawing Done By</TableCell>
          <TableCell
            style={{
              fontWeight: 700,
              ...borderRight,
            }}
          >
            No. of Embryos Survived
          </TableCell>
        </TableRow>

        {data &&
          data.map((item, index) => (
            <TableRow key={index}>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('thawingDate', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('dayOfEmbryoCulture', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('noOfEmbThawed', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('qualityOfEmbryosBeforeVitrification', index)[0]}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('qualityOfEmbryosBeforeVitrification', index)[1]}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('qualityOfEmbryosBeforeVitrification', index)[2]}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('qualityOfEmbryosAfterThawing', index)[0]}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('qualityOfEmbryosAfterThawing', index)[1]}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('qualityOfEmbryosAfterThawing', index)[2]}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('thawingDoneBy', index)}
                </div>
              </TableCell>
              <TableCell style={borderRight}>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('noOfEmbSurvived', index)}
                </div>
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
}

export default FetThawingTable;
